(() => {
  const desktopQuery = window.matchMedia('(min-width: 46.9375rem)');
  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let lenis;

  const stop = () => {
    if (!lenis) return;

    window.dispatchEvent(new CustomEvent('fieldstudy:lenis-stop', { detail: { lenis } }));
    lenis.destroy();
    lenis = undefined;
    window.fieldStudyLenis = undefined;
  };

  const start = () => {
    if (lenis || !desktopQuery.matches || reducedMotionQuery.matches || typeof window.Lenis !== 'function') return;

    lenis = new window.Lenis({
      autoRaf: true,
      duration: 1.12,
      easing: (progress) => Math.min(1, 1.001 - Math.pow(2, -10 * progress)),
      smoothWheel: true,
      wheelMultiplier: 1,
      syncTouch: false,
      prevent: (node) => Boolean(node.closest?.('dialog, details[scroll-lock], [data-native-scroll]')),
    });

    window.fieldStudyLenis = lenis;
    window.dispatchEvent(new CustomEvent('fieldstudy:lenis-start', { detail: { lenis } }));
  };

  const update = () => {
    if (desktopQuery.matches && !reducedMotionQuery.matches) {
      start();
      return;
    }

    stop();
  };

  desktopQuery.addEventListener('change', update);
  reducedMotionQuery.addEventListener('change', update);
  update();
})();
